import type { Metadata } from "@/lib/head";

import CustomerScreenShell from "@/components/customer-screen-shell";
import Notice from "@buildpy/ui/notice";

// 404 는 HTML 이 이 메타로 그려진다(Next 15.0) — 없으면 제목이 루트 기본값 「빌드파이」 로 나가 하이드레이션 뒤에야 바뀐다.
export const metadata: Metadata = { title: "시공사례" };

// 없는 조직·비공개 사례 — 어느 쪽인지 가르지 않고 같은 안내.
const NotFound = () => (
  <CustomerScreenShell centered>
    <Notice body="주소가 잘못되었거나 더 이상 공개하지 않는 사례입니다." title="시공사례를 찾을 수 없습니다" />
  </CustomerScreenShell>
);

export default NotFound;
